import { httpClient } from '@/utils/http-client';
export class BaseService {
    httpClient;
    basePath;
    constructor(basePath) {
        this.httpClient = httpClient;
        this.basePath = basePath;
    }
    async getAll() {
        const response = await this.httpClient.get(this.basePath);
        return response.data;
    }
    async getById(id) {
        const response = await this.httpClient.get(`${this.basePath}/${id}`);
        return response.data;
    }
    async create(payload) {
        const response = await this.httpClient.post(this.basePath, payload);
        return response.data;
    }
    async update(id, payload) {
        const response = await this.httpClient.put(`${this.basePath}/${id}`, payload);
        return response.data;
    }
    async delete(id) {
        const response = await this.httpClient.delete(`${this.basePath}/${id}`);
        return response.data;
    }
    async patch(id, payload) {
        const response = await this.httpClient.patch(`${this.basePath}/${id}`, payload);
        return response.data;
    }
}
